export default __webpack_public_path__ + "static/Partner_with_us-a48b75db0951d15e3d55b28a0c620a4f.svg";